import moment from 'moment';
import typeCheck from 'common/util/typeCheck';

import {
  PRE_LEASE_LIVE_STATUS_LIVE,
  PRE_LEASE_LIVE_STATUS_CLOSE_DUE_DATE,
  PRE_LEASE_LIVE_STATUS_PAST_DATE,
  PRE_LEASE_LIVE_STATUS_END,
} from 'common/preLeaseConstants';

export function calculatePreLeaseLiveStatus({ preLease, listing }) {
  typeCheck('preLease::NonEmptyObject', preLease);
  typeCheck('listing::NonEmptyObject', listing);

  if (listing.isTourable || preLease.completedDate) {
    return PRE_LEASE_LIVE_STATUS_END;
  }

  const startDate = moment(preLease.startDate);
  const endDate = moment(preLease.endDate);
  const now = moment().endOf('day');

  if (now.isBefore(startDate)) {
    return PRE_LEASE_LIVE_STATUS_LIVE;
  }

  if (now.isSameOrBefore(endDate)) {
    return PRE_LEASE_LIVE_STATUS_CLOSE_DUE_DATE;
  }

  return PRE_LEASE_LIVE_STATUS_PAST_DATE;
}
